// eslint-disable-next-line spaced-comment
/// <reference path="./types.d.ts" />

import packageJson from './package.json';

export const { version } = packageJson;
export * from './src/controls';
export * from './src/types';
